import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
var css = {
  "messageBox": "rui-vzp8j",
  "message": "rui-ZIqlu"
};
import classNames from 'classnames';
var ToastMessage = /*#__PURE__*/function (_Component) {
  function ToastMessage() {
    _classCallCheck(this, ToastMessage);
    return _callSuper(this, ToastMessage, arguments);
  }
  _inherits(ToastMessage, _Component);
  return _createClass(ToastMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;
      var _this$props = this.props,
        onExpired = _this$props.onExpired,
        expiration = _this$props.expiration;
      this.timer = setTimeout(function () {
        delete _this.timer;
        onExpired === null || onExpired === void 0 ? void 0 : onExpired();
      }, expiration);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        position = _this$props2.position,
        className = _this$props2.className;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(className, css.messageBox),
        style: {
          position: position
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: css.message
      }, children));
    }
  }]);
}(Component);
ToastMessage.defaultProps = {
  expiration: 5000,
  onExpired: function onExpired() {},
  position: 'fixed',
  className: ''
};
export default ToastMessage;